<template>
  <div id="home">
    <full-page ref="fullpage" :options="options" class="fullpage">
      <section1 @moveTo="moveTo"></section1>
      <section2></section2>
      <section3></section3>
      <section4></section4>
      <section5></section5>
      <section6></section6>
    </full-page>
    <siderbar @moveTo="moveTo"></siderbar>
    <span v-show="!curMenu" class="age16" @click="setShow12"></span>
    <!-- <pin-btns></pin-btns> -->
    <div v-if="show12" class="age12-pop-box">
      <div class="age12-pop" :class="show12 && 'transPop'">
        <div class="close" @click="setShow12">close</div>
        <div class="age-txt" v-html="content12"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import utils from "@/libs/utils";
import Section1 from "@/components/Section1";
import Section2 from "@/components/Section2";
import Section3 from "@/components/Section3";
import Section4 from "@/components/Section4";
import Section5 from "@/components/Section5";
import Section6 from "@/components/Section6";
import Siderbar from "@/components/Siderbar";
// import PinBtns from "@/components/PinBtns";

const _hmt = window._hmt;
export default {
  name: "Home",
  components: {
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Siderbar,
    // PinBtns
  },
  data() {
    return {
      show12: false,
      content12: "",
      canScroll: true,
      options: {
        name: "as",
        start: 0,
        loop: false,
        scrollingSpeed: 0,
        stopPageScroll: true,
        keyboardScrolling: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad,
        afterResize: this.afterResize
      }
    };
  },
  computed: {
    ...mapState(["contact", "curPage"]),
    curMenu() {
      return this.curPage < 6 ? this.curPage : -1;
    }
  },
  mounted() {
    const page = this.$route.query.page;
    if (page) {
      this.moveTo(page);
    }
    this.getAge12();
  },
  // http://localhost:8081/#/detail?catid=6434&sn=146ce7as
  methods: {
    ...mapActions(["changeCurPage"]),
    setShow12() {
      this.show12 = !this.show12;
    },
    async getAge12() {
      try {
        const { data } = await this.$api.getKMSConfig("wwjs", { sn: "132el3nl" });
        this.content12 = data.content;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    },
    moveTo(page) {
      this.$refs.fullpage.api.moveTo(page);
    },
    onLeave() {
      if (!this.canScroll) {
        return false;
      }
      this.canScroll = false;
    },
    afterLoad(prev, active) {
      this.changeCurPage(active.index);
      _hmt.push([
        "_trackEvent",
        "slide",
        "page" + (active.index + 1),
        utils.checkRealOperaSys()
      ]);
      this.throttle();
    },
    afterResize() {
      this.$refs.fullpage.api.reBuild();
    },
    throttle() {
      // 防止触摸板滚动一次翻多页
      return setTimeout(() => {
        this.canScroll = true;
      }, 1500);
    }
  }
};
</script>
